// Slice RTK per `state.distanceCache` — cache in-memory delle distanze OSRM
// tra coppie di indirizzi. Preserva la semantica del vecchio handler:
//   - payload `null` → reset totale
//   - payload object → merge con cap a `MAX_CACHE` keys (LRU naive: si tengono
//     le ultime N inserite)

import { createSlice } from '@reduxjs/toolkit';

const MAX_CACHE = 500;
const initialState = {};

const distanceCacheSlice = createSlice({
  name: 'distanceCache',
  initialState,
  reducers: {
    set: (state, action) => {
      const payload = action.payload;
      if (payload === null) return initialState;
      const next = { ...state, ...payload };
      const keys = Object.keys(next);
      if (keys.length <= MAX_CACHE) return next;
      const trimmed = {};
      keys.slice(-MAX_CACHE).forEach((k) => {
        trimmed[k] = next[k];
      });
      return trimmed;
    },
  },
});

export const { set: setDistanceCache } = distanceCacheSlice.actions;
export default distanceCacheSlice.reducer;
